var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 96,
    viewBox: "0 0 72 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6009 62.6497L65.6342 62.624L65.6644 62.5948L65.9524 62.3162C69.0187 59.349 70.75 55.2646 70.75 50.9977V18.1826C70.75 13.6555 68.8019 9.34722 65.4028 6.35705L65.1525 6.1369L64.6571 6.70002L65.1525 6.1369L64.0584 5.17441C61.1832 2.64513 57.485 1.25 53.6556 1.25H17.1615C12.8598 1.25 8.75193 3.03934 5.82225 6.18924L5.46722 6.57095C2.75672 9.4852 1.25 13.3175 1.25 17.2974V50.414C1.25 54.3939 2.75672 58.2262 5.46722 61.1405L6.30796 62.0444L6.45941 62.2072C9.59506 65.5786 14.0489 67.4091 18.6491 67.217L57.5173 65.5946C60.4515 65.4721 63.2755 64.4433 65.6009 62.6497Z",
    fill: "url(#paint0_linear_252_10394)",
    stroke: "url(#paint1_linear_252_10394)",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_10394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5111 59.1875H45.2726L41.1514 59.4445L44.2423 59.316L47.3332 59.1875H35.2192H53.5111L43.0754 59.1875L43.2844 59.1875H42.1817H35.2192H20.5494C12.5935 59.1875 6.12109 65.7489 6.12109 73.8139C6.12109 81.879 12.5935 88.4403 20.5494 88.4403C23.0963 88.4403 25.6004 87.7577 27.7911 86.4662C29.6104 85.3936 31.182 83.9235 32.3849 82.1778H41.6754C42.8784 83.9235 44.45 85.3936 46.2693 86.4662C48.46 87.7577 50.9641 88.4403 53.511 88.4403C61.4668 88.4403 67.9393 81.879 67.9393 73.8139C67.9393 65.7489 61.467 59.1875 53.5111 59.1875ZM53.5111 84.7684C49.72 84.7684 46.1588 82.7127 44.2172 79.4033L43.6907 78.5059H30.3697L29.8431 79.4033C27.9015 82.7127 34.1608 77.2002 30.3697 77.2002C24.4111 77.2002 9.74314 73.8139 9.74314 73.8139C9.74314 73.8139 26.9504 79.4033 32.909 79.4033L43.6907 81.378L55.5756 87.6447L62.7878 81.378C68.7463 81.378 64.3171 67.7735 64.3171 73.8139C64.3171 79.8543 59.4697 84.7684 53.5111 84.7684Z",
    fill: "url(#paint2_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0989 72.1022V68.7158H18.4767V72.1022H15.1362V75.7741H18.4767V79.1604H22.0989V75.7741H25.4394V72.1022H22.0989Z",
    fill: "url(#paint3_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3368 67.4182L47.3394 73.498L49.9006 76.0944L55.8981 70.0146L53.3368 67.4182Z",
    fill: "url(#paint4_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8441 71.9876L51.8467 78.0674L54.4079 80.6638L60.4054 74.584L57.8441 71.9876Z",
    fill: "url(#paint5_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6212 72.1025H31.999V75.7744H35.6212V72.1025Z",
    fill: "url(#paint6_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0616 72.1025H38.4395V75.7744H42.0616V72.1025Z",
    fill: "url(#paint7_linear_252_10394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1811 65.5742H31.8784V69.2461H42.1811V65.5742Z",
    fill: "url(#paint8_linear_252_10394)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6665 29.7081V33.763C56.6659 34.3005 56.455 34.8159 56.0801 35.196C55.7051 35.5761 55.1968 35.7899 54.6665 35.7905H51.8159C51.4582 37.1691 50.917 38.492 50.2072 39.7226L52.2251 41.7742C52.5974 42.1547 52.8063 42.6689 52.8061 43.2048C52.806 43.7407 52.5969 44.2549 52.2244 44.6352L49.3911 47.5071C49.0111 47.8756 48.5055 48.0813 47.9796 48.0813C47.4538 48.0813 46.9482 47.8756 46.5682 47.5071L44.5454 45.4621C43.3314 46.1817 42.0265 46.7303 40.6665 47.093V49.9827C40.6659 50.5202 40.455 51.0356 40.0801 51.4157C39.7051 51.7958 39.1968 52.0096 38.6665 52.0101H34.6665C34.1362 52.0096 33.6279 51.7958 33.2529 51.4157C32.878 51.0356 32.6671 50.5202 32.6665 49.9827V47.093C31.8405 46.8712 31.0336 46.5815 30.2541 46.2267C30.1563 46.1812 30.0708 46.1125 30.0047 46.0265C29.9386 45.9404 29.8939 45.8395 29.8743 45.7323C29.8548 45.625 29.8609 45.5146 29.8923 45.4103C29.9236 45.3059 29.9793 45.2108 30.0545 45.1328L32.8879 42.2537C32.973 42.1673 33.0797 42.1059 33.1965 42.076C33.3132 42.046 33.4359 42.0487 33.5513 42.0837C34.5619 42.3914 35.6113 42.5481 36.6665 42.5487C38.7762 42.5487 40.8385 41.9145 42.5926 40.7263C44.3467 39.5382 45.7139 37.8494 46.5212 35.8735C47.3286 33.8977 47.5398 31.7235 47.1282 29.626C46.7166 27.5285 45.7007 25.6018 44.209 24.0895C42.7172 22.5773 40.8166 21.5474 38.7475 21.1302C36.6783 20.713 34.5336 20.9271 32.5845 21.7455C30.6355 22.5639 28.9696 23.9499 27.7975 25.7281C26.6254 27.5063 25.9998 29.5969 25.9998 31.7355C26.0008 32.8031 26.1553 33.8649 26.4585 34.8873C26.493 35.0041 26.4957 35.1282 26.4663 35.2465C26.4368 35.3647 26.3763 35.4726 26.2912 35.5588L23.451 38.4376C23.3742 38.5142 23.2803 38.5708 23.1774 38.6028C23.0744 38.6348 22.9653 38.6411 22.8594 38.6214C22.7535 38.6016 22.6539 38.5562 22.5689 38.4892C22.4839 38.4221 22.4161 38.3353 22.3713 38.236C22.0216 37.4457 21.736 36.6278 21.5171 35.7905H18.6665C18.1362 35.7899 17.6279 35.5761 17.2529 35.196C16.878 34.8159 16.6671 34.3005 16.6665 33.763V29.7081C16.6671 29.1705 16.878 28.6552 17.2529 28.2751C17.6279 27.895 18.1362 27.6812 18.6665 27.6806H21.5171C21.8749 26.3019 22.4161 24.9789 23.1258 23.7481L21.1079 21.6969C20.7356 21.3164 20.5268 20.8022 20.5269 20.2663C20.527 19.7303 20.7361 19.2162 21.1086 18.8359L23.9419 15.964C24.3219 15.5955 24.8275 15.3898 25.3534 15.3898C25.8792 15.3898 26.3848 15.5955 26.7648 15.964L28.7876 18.009C30.0016 17.2894 31.3065 16.7408 32.6665 16.3781V13.4884C32.6671 12.9509 32.878 12.4355 33.2529 12.0554C33.6279 11.6753 34.1362 11.4615 34.6665 11.4609H38.6665C39.1968 11.4615 39.7051 11.6753 40.0801 12.0554C40.455 12.4355 40.6659 12.9509 40.6665 13.4884V16.3781C42.0265 16.7408 43.3314 17.2894 44.5454 18.009L46.5692 15.9633C46.9493 15.5952 47.4548 15.3898 47.9804 15.39C48.5061 15.3901 49.0115 15.5957 49.3914 15.964L52.2244 18.8362C52.5971 19.2166 52.8062 19.731 52.8062 20.2671C52.8062 20.8032 52.5971 21.3175 52.2244 21.6979L50.2072 23.7481C50.9169 24.9789 51.4581 26.3019 51.8159 27.6806H54.6665C55.1968 27.6812 55.7051 27.895 56.0801 28.2751C56.455 28.6552 56.6659 29.1705 56.6665 29.7081ZM44.2606 28.2862C44.2235 28.1779 44.16 28.0809 44.076 28.0041C43.992 27.9273 43.8902 27.8733 43.7801 27.8471C43.6701 27.8209 43.5552 27.8232 43.4463 27.854C43.3374 27.8848 43.2379 27.943 43.1571 28.0232L40.1235 31.0987L38.0021 30.3816L37.2951 28.2311L40.3286 25.1559C40.4077 25.074 40.4651 24.9731 40.4955 24.8627C40.5259 24.7523 40.5282 24.6358 40.5023 24.5242C40.4764 24.4126 40.4232 24.3095 40.3474 24.2243C40.2717 24.1392 40.176 24.0748 40.0692 24.0372C38.9275 23.6465 37.7025 23.5773 36.5251 23.8369C35.3476 24.0965 34.2617 24.6753 33.3832 25.5115C32.5048 26.3476 31.8667 27.4098 31.537 28.5848C31.2073 29.7597 31.1984 31.0033 31.5112 32.183L17.7013 46.1825C17.0762 46.8162 16.7251 47.6757 16.7251 48.5718C16.7251 49.468 17.0762 50.3275 17.7013 50.9611C18.3264 51.5948 19.1742 51.9508 20.0583 51.9508C20.9423 51.9508 21.7901 51.5948 22.4152 50.9611L36.2251 36.9616C37.3888 37.2787 38.6156 37.2697 39.7746 36.9355C40.9337 36.6013 41.9815 35.9544 42.8063 35.0639C43.6311 34.1734 44.2021 33.0726 44.4582 31.8789C44.7143 30.6853 44.646 29.4435 44.2606 28.2862Z",
    fill: "url(#paint9_linear_252_10394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_10394",
    x1: 36,
    y1: 2,
    x2: 36.0514,
    y2: 66.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_10394",
    x1: 36,
    y1: 2,
    x2: 36.0514,
    y2: 66.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_10394",
    x1: 37.0302,
    y1: 59.1875,
    x2: 37.0417,
    y2: 88.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_10394",
    x1: 20.2878,
    y1: 79.1604,
    x2: 20.2878,
    y2: 68.7158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_252_10394",
    x1: 52.8993,
    y1: 73.0545,
    x2: 50.3032,
    y2: 70.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_252_10394",
    x1: 57.4066,
    y1: 77.6239,
    x2: 54.8105,
    y2: 75.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_252_10394",
    x1: 33.8101,
    y1: 75.7744,
    x2: 33.8101,
    y2: 72.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_252_10394",
    x1: 40.2505,
    y1: 75.7744,
    x2: 40.2505,
    y2: 72.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_252_10394",
    x1: 37.0297,
    y1: 69.2461,
    x2: 37.0297,
    y2: 65.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_252_10394",
    x1: 36.6665,
    y1: 52.0101,
    x2: 36.6665,
    y2: 11.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_10394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.8182,
    height: 62.667,
    fill: "white",
    transform: "translate(6.12109 33.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.5c06cdfcd75fce17dc995777c74daa1d.svg";
export { ForwardRef as ReactComponent };